/*
 * Project: LegalPlace assistant
 * File: src\logic\utils\encoding.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

export function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(new RegExp('%([0-9A-F]{2})', 'g'), (match, p1) => String.fromCharCode(parseInt(p1, 16))));
}

export function b64DecodeUnicode(str) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));
}


window.encode_ = b64EncodeUnicode;

window.decode_ = b64DecodeUnicode;



// WEBPACK FOOTER //
// ./src/logic/utils/encoding.js